import { ModuleProps } from '../components/Module';
import { getModuleFactory } from '../factories/getModuleFactory';
import { moduleConfigFactory } from '../factories/moduleConfigFactory';
import { useDynamicScript } from './useDynamicScript';

export const usePreloadModule = ({
  appName,
  moduleName,
  module,
  log = () => {},
  error = () => {}
}: { appName?: string; moduleName?: string } & Partial<Omit<ModuleProps, 'moduleProps'>>) => {
  const theModule = module ?? moduleConfigFactory(appName!, moduleName!);
  const { ready } = useDynamicScript({ url: theModule.url, log, error });

  if (ready) {
    const { factory, isLazy } = getModuleFactory(theModule.appName, theModule.module, log);
    if (isLazy) {
      factory();
    }
  }
};
